import React from 'react'
import gradient from "../Assets/gradient-hero.png";
import { Link } from "react-router";
import Image from 'react-bootstrap/Image';

export default function ContactBlock() {
    return (
        <section className='px-5 padding-section-large bg-theme contact-section'>
            <h1 className='heading-style-h1'>Get Parabola</h1>
            <h1 className='heading-style-h1 text-white'>at your organisation.</h1>
            <div className='pt-4'>
                <p className="text-size-medium">Transform your workplace culture and drive success.</p>
                <div className="button-group">
                    <Link to="/contact" className="btn btn-dark rounded-pill px-5 py-3">Get In Touch</Link>
                </div>
            </div>
            <div className="footer-pill-right-wrap"><Image src={gradient} /></div>
        </section>
    )
}
